import { useActionsFiltersStore } from '@/contexts/action-plans/stores/ActionsFilters.store'
import { useActionsListFiltersStore } from '@/contexts/action-plans/stores/ActionsListFilters.store'
import { useActionPlanFiltersStore } from '@/contexts/action-plans/stores/ActionPlanFilters.store'
import { useActionPlansListFiltersStore } from '@/contexts/action-plans/stores/ActionPlansListFilters.store'

export function clearFilterStores(): void {
  const filterStores = [
    useActionsFiltersStore(),
    useActionsListFiltersStore(),
    useActionPlansListFiltersStore(),
    useActionPlanFiltersStore(),
  ]

  filterStores.forEach((store) => {
    store.$reset()
  })
}
